var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF004F;}\n\t.st1{fill:#00F2EA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.7,18c3.2,2.3,7.2,3.7,11.5,3.7v-8.2c-0.8,0-1.6-0.1-2.4-0.3v6.5c-4.3,0-8.2-1.4-11.5-3.7v16.8 c0,8.4-6.8,15.2-15.2,15.2c-3.1,0-6-0.9-8.5-2.6c2.8,2.8,6.6,4.6,10.9,4.6c8.4,0,15.2-6.8,15.2-15.2L35.7,18L35.7,18z M38.6,9.8 c-1.6-1.8-2.7-4.1-3-6.7V2h-2.3C34,5.3,35.9,8.1,38.6,9.8L38.6,9.8z M14.9,39c-0.9-1.2-1.4-2.7-1.4-4.2c0-3.8,3.1-6.9,7-6.9 c0.7,0,1.4,0.1,2.1,0.3v-8.4c-0.8-0.1-1.6-0.2-2.4-0.1v6.5c-0.7-0.2-1.4-0.3-2.1-0.3c-3.8,0-6.9,3.1-6.9,6.9 C11.1,35.5,12.7,37.9,14.9,39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,16c3.2,2.3,7.2,3.7,11.5,3.7v-6.5c-2.4-0.5-4.5-1.8-6.1-3.5C35.9,8.1,34,5.3,33.4,2h-6v32.8c0,3.8-3.1,6.9-7,6.9 c-2.3,0-4.3-1.1-5.5-2.7c-2.3-1.1-3.8-3.5-3.8-6.2c0-3.8,3.1-6.9,6.9-6.9c0.7,0,1.4,0.1,2.1,0.3v-6.5c-8.2,0.2-14.9,6.9-14.9,15.2 c0,4.1,1.7,7.9,4.3,10.6c2.4,1.6,5.3,2.6,8.5,2.6c8.4,0,15.2-6.8,15.2-15.2L33.3,16L33.3,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.7,13.2v-1.7c-2.1,0-4.3-0.6-6.1-1.7C40.3,11.5,42.4,12.7,44.7,13.2z M33.4,2c-0.1-0.3-0.1-0.6-0.1-0.9V0 H25v32.8c0,3.8-3.1,6.9-6.9,6.9c-1.1,0-2.2-0.3-3.1-0.7c1.3,1.7,3.3,2.7,5.5,2.7c3.8,0,6.9-3.1,7-6.9V2H33.4z M20.2,19.6v-1.9 c-0.7-0.1-1.4-0.1-2.1-0.1c-8.4,0-15.2,6.8-15.2,15.2c0,5.3,2.7,9.9,6.7,12.6c-2.7-2.7-4.3-6.5-4.3-10.6 C5.3,26.5,11.9,19.8,20.2,19.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.3457eba8d665bde2fad5011854021843.svg";
export { ForwardRef as ReactComponent };